import * as React from "react";
import type { SVGProps } from "react";
import { memo } from "react";
const SvgScreenShare = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M16 10.5H8m8 0-3 3m3-3-3-3M12 20h4m-4 0H8m4 0v-4m0 0H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v1m-8 9h7a1 1 0 0 0 1-1v-4" />
  </svg>
);
const Memo = memo(SvgScreenShare);
export default Memo;
